import { Box, DashboardModule, Form } from '@domain-group/suit-theme'

import { digObject } from '@domain-group/javascript-utils'

import { UseFormPayload } from '@domain-group/react-hooks'

import InfoToolTip from '@components/InfoToolTip'

interface LandDetailsProps {
  campaignForm: UseFormPayload,
}

const LandDetails = (props: LandDetailsProps) => {
  const { campaignForm } = props

  const {
    entityState: {
      council_rates,
      extra_fields,
      frontage,
      land_area,
      land_area_units,
      land_details,
      land_zoning,
      lot_number,
      municipality,
      site_name,
    },
    handlers,
  } = campaignForm

  const landTaxPeriod = digObject(extra_fields, 'land_tax.period', '')
  const landTaxValue = digObject(extra_fields, 'land_tax.value', '')

  const otherOutgoingsPeriod = digObject(extra_fields, 'other_outgoings.period', '')
  const otherOutgoingsValue = digObject(extra_fields, 'other_outgoings.value', '')

  const strataAdminPeriod = digObject(extra_fields, 'strata_admin.period', '')
  const strataAdminValue = digObject(extra_fields, 'strata_admin.value', '')

  const strataSinkingPeriod = digObject(extra_fields, 'strata_sinking.period', '')
  const strataSinkingValue = digObject(extra_fields, 'strata_sinking.value', '')

  const waterRatesPeriod = digObject(extra_fields, 'water_rates.period', '')
  const waterRatesValue = digObject(extra_fields, 'water_rates.value', '')

  return (
    <DashboardModule title="Land Details">
      <Form padding="large">
        <Form.Row>
          <Form.Row>
            <Form.Field label="Lot Number">
              <input
                name="lot_number"
                type="text"
                value={lot_number}
                {...handlers}
              />
            </Form.Field>

            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="Land Area" marginTop={['large', 0]}>
              <input
                name="land_area"
                type="text"
                value={land_area}
                {...handlers}
              />
            </Form.Field>
          </Form.Row>

          <Form.Row>
            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="Land Area Units" marginTop={['large', 0]}>
              {/*
               // @ts-expect-error TS2322 */}
              <select name="land_area_units" value={land_area_units} {...handlers}>
                <option value="">Please Select...</option>
                <option value="hectare">Hectares</option>
                <option value="acre">Acres</option>
                <option value="squareMeter">Square Metres</option>
                <option value="square">Squares</option>
              </select>
            </Form.Field>

            {/*
             // @ts-expect-error TS2322 */}
            <Form.Field label="Land Details" marginTop={['large', 0]}>
              <input
                name="land_details"
                type="text"
                value={land_details}
                {...handlers}
              />
            </Form.Field>
          </Form.Row>
        </Form.Row>

        <Form.Row>
          <Form.Row>
            <Form.Field label="Frontage (m)" marginTop="large">
              <input
                name="frontage"
                step="0.01"
                type="number"
                value={frontage}
                {...handlers}
              />
            </Form.Field>

            <Form.Field label="Council Rates" marginTop="large">
              <input
                name="council_rates"
                type="text"
                value={council_rates}
                {...handlers}
              />
            </Form.Field>
          </Form.Row>

          <Form.Field label="Land Zoning" marginTop="large">
            <input
              name="land_zoning"
              type="text"
              value={land_zoning}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>

        <Form.Row>
          <Form.Field label="Water Rates" marginTop="large">
            <input
              name="extra_fields.water_rates.value"
              type="text"
              value={waterRatesValue}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Water Rates Period" marginTop="large">
            {/*
             // @ts-expect-error TS2322 */}
            <select name="extra_fields.water_rates.period" value={waterRatesPeriod} {...handlers}>
              <option value="">Select Period...</option>
              <option value="quarter">Per Quarter</option>
              <option value="year">Per Year</option>
            </select>
          </Form.Field>
        </Form.Row>

        <Form.Row>
          <Form.Field label="Strata - Admin Fees" marginTop="large">
            <input
              name="extra_fields.strata_admin.value"
              type="text"
              value={strataAdminValue}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Strata - Admin Period" marginTop="large">
            {/*
             // @ts-expect-error TS2322 */}
            <select name="extra_fields.strata_admin.period" value={strataAdminPeriod} {...handlers}>
              <option value="">Select Period...</option>
              <option value="quarter">Per Quarter</option>
              <option value="year">Per Year</option>
            </select>
          </Form.Field>
        </Form.Row>

        <Form.Row>
          <Form.Field label="Strata - Sinking Fees" marginTop="large">
            <input
              name="extra_fields.strata_sinking.value"
              type="text"
              value={strataSinkingValue}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Strata - Sinking Period" marginTop="large">
            {/*
             // @ts-expect-error TS2322 */}
            <select name="extra_fields.strata_sinking.period" value={strataSinkingPeriod} {...handlers}>
              <option value="">Select Period...</option>
              <option value="quarter">Per Quarter</option>
              <option value="year">Per Year</option>
            </select>
          </Form.Field>
        </Form.Row>

        <Form.Row>
          <Form.Field label="Land Tax" marginTop="large">
            <input
              name="extra_fields.land_tax.value"
              type="text"
              value={landTaxValue}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Land Tax Period" marginTop="large">
            {/*
             // @ts-expect-error TS2322 */}
            <select name="extra_fields.land_tax.period" value={landTaxPeriod} {...handlers}>
              <option value="">Select Period...</option>
              <option value="quarter">Per Quarter</option>
              <option value="year">Per Year</option>
            </select>
          </Form.Field>
        </Form.Row>

        <Form.Row>
          <Form.Field label="Other Outgoings" marginTop="large">
            <input
              name="extra_fields.other_outgoings.value"
              type="text"
              value={otherOutgoingsValue}
              {...handlers}
            />
          </Form.Field>

          <Form.Field label="Other Outgoings Period" marginTop="large">
            {/*
             // @ts-expect-error TS2322 */}
            <select name="extra_fields.other_outgoings.period" value={otherOutgoingsPeriod} {...handlers}>
              <option value="">Select Period...</option>
              <option value="quarter">Per Quarter</option>
              <option value="year">Per Year</option>
            </select>
          </Form.Field>
        </Form.Row>

        <Form.Row>
          <Form.Field label="Municipality" marginTop="large">
            <input type="text" name="municipality" value={municipality} {...handlers} />
          </Form.Field>

          <Form.Field
            // @ts-expect-error TS2322
            label={(
              <>
                <Box marginRight="small">Site Name</Box>

                <InfoToolTip>
                  The name or site of a commercial listing e.g. Victoria Gardens Shopping Complex
                </InfoToolTip>
              </>
            )}
            marginTop="large"
          >
            <input
              name="site_name"
              type="text"
              value={site_name}
              {...handlers}
            />
          </Form.Field>
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default LandDetails
